import { t } from 'i18next';
import { SettingToggleRow } from '../../../../components/setting-toggle-row';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { DOCS_URLS } from '../../constants';
import { useStorefrontOptionsControls } from '../../context/storefront-options-context';
import { OptionsCard } from '../options-card';

const CARD =
  'features:storefront_options.pages.storefront_options_page.cards.pricing_settings' satisfies I18nPrefix;

export function PricingSettingsCard() {
  const { options, setDisplay, siteSettings } = useStorefrontOptionsControls();
  const { display } = options;

  return (
    <OptionsCard title={t(`${CARD}.title`)} subtitle={t(`${CARD}.subtitle`)}>
      <SettingToggleRow
        label={t(`${CARD}.fields.savings_use_rrp.label`)}
        description={t(`${CARD}.fields.savings_use_rrp.description`)}
        checked={display.savingsUseRrp}
        onChange={(checked) => setDisplay('savingsUseRrp', checked)}
        learnMoreUrl={DOCS_URLS.pricing.pricingDisplay}
      />
      <SettingToggleRow
        label={t(`${CARD}.fields.show_rrp_toggle.label`)}
        description={t(`${CARD}.fields.show_rrp_toggle.description`)}
        checked={display.showRrpToggle}
        onChange={(checked) => setDisplay('showRrpToggle', checked)}
        learnMoreUrl={DOCS_URLS.pricing.showRrpToggle}
      />
      <SettingToggleRow
        label={t(`${CARD}.fields.show_price_break_savings.label`)}
        description={t(`${CARD}.fields.show_price_break_savings.description`)}
        checked={display.showPriceBreakSavings}
        onChange={(checked) => setDisplay('showPriceBreakSavings', checked)}
        learnMoreUrl={DOCS_URLS.pricing.pricingDisplay}
      />
      <SettingToggleRow
        label={t(`${CARD}.fields.round_price_break_percentages.label`)}
        description={t(`${CARD}.fields.round_price_break_percentages.description`)}
        checked={display.roundPriceBreakPercentages}
        onChange={(checked) => setDisplay('roundPriceBreakPercentages', checked)}
        learnMoreUrl={DOCS_URLS.pricing.pricingDisplay}
      />
      <SettingToggleRow
        label={t(`${CARD}.fields.apply_price_breaks_across_variants.label`)}
        description={t(`${CARD}.fields.apply_price_breaks_across_variants.description`)}
        checked={siteSettings.values.applyPriceBreaksAcrossVariants}
        onChange={(checked) => siteSettings.set('applyPriceBreaksAcrossVariants', checked)}
        learnMoreUrl={DOCS_URLS.pricing.applyPriceBreaksAcrossVariants}
      />
      <SettingToggleRow
        label={t(`${CARD}.fields.dark_theme.label`)}
        description={t(`${CARD}.fields.dark_theme.description`)}
        checked={display.darkTheme}
        onChange={(checked) => setDisplay('darkTheme', checked)}
        learnMoreUrl={DOCS_URLS.pricing.darkTheme}
      />
    </OptionsCard>
  );
}
